import { getSubscribeMessageTemplateIdDocument } from '../graphql/docs';
import { fetcher } from '../graphql/fetcher/index';

/**
 * 获取渠道配置信息
 */
export const fetchGetSubscribeMessageTemplateId = async () => {
  const res = await fetcher.query(getSubscribeMessageTemplateIdDocument, {});
  return res.data.value?.getSubscribeMessageTemplateId;
};
